import { DRUPAL_NODE_DISPLAY, type DrupalImage, type DrupalNodePage } from '@commons/types/drupal';

import PageNodeCard from './Card';
import PageNodeLabel from './Label';
import PageNodeTile from './Tile';

/**
 * Type definition of a Page node properties.
 */

export type PageNodeProps = DrupalNodePage & {
  image?: DrupalImage;
  summary?: string;
};

/**
 * Page node component.
 *
 * Renders a component based on the display type.
 */

export const PageNode = (props: PageNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <PageNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <PageNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Tile:
      return <PageNodeTile {...props} />;
  }
};

export default PageNode;
